import React from 'react'
import { Modal } from 'react-bootstrap'
import useGetCheckStatus from './hooks/useGetCheckStatus'
import { useParams } from 'react-router-dom'
interface IModalProps {
    show: boolean
    onHide: () => void
    name: string
    poolShip: number | undefined
    setIsOpenCashinModal: React.Dispatch<React.SetStateAction<boolean>>
    setCashinAmount: React.Dispatch<React.SetStateAction<number>>
}
export default function SettlementConfirmModal({
    show,
    onHide,
    name,
    poolShip,
    setIsOpenCashinModal,
    setCashinAmount,
}: IModalProps) {
    const { mutate } = useGetCheckStatus(setIsOpenCashinModal, setCashinAmount)
    const { moneyPool } = useParams()
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-xs">
                <p className=" my-1">آیا مایل به تسویه و اخراج</p>
                <p className=" my-1">{name}</p>
                <p className=" my-1">هستید؟</p>
                <hr />
                <p
                    className=" my-3 text-green-1"
                    onClick={() => {
                        const payload: IGetSettlementCheckStatusPayload = {
                            moneyPool: moneyPool,
                            poolShip: poolShip,
                        }
                        mutate(payload)
                        onHide()
                    }}
                >
                    تایید
                </p>
                <hr />
                <p
                    className=" my-2"
                    onClick={() => {
                        onHide()
                    }}
                >
                    بستن
                </p>
            </div>
        </Modal>
    )
}
